'use strict';

var WidgetController_type = require('./WidgetController/type.js');

const getDimensionValue = ({ computedStyles, dimension = {}, width, itemSpacing, columns, containerPadding, widgetPadding, }) => {
    const widgetLeft = (widgetPadding === null || widgetPadding === void 0 ? void 0 : widgetPadding.left) || 0;
    const widgetRight = (widgetPadding === null || widgetPadding === void 0 ? void 0 : widgetPadding.right) || 0;
    const containerLeft = (containerPadding === null || containerPadding === void 0 ? void 0 : containerPadding.left) || 0;
    const containerRight = (containerPadding === null || containerPadding === void 0 ? void 0 : containerPadding.right) || 0;
    const widthCalculationRelativeUnit = "100vw";
    switch (dimension.type) {
        case WidgetController_type.IDimensionType.TYPE_RELATIVE: {
            switch (dimension.reference) {
                case WidgetController_type.IRelativeDimensionReference.RELATIVE_DIMENSION_REFERENCE_WIDTH:
                    return `calc(${dimension.value} * ${computedStyles.width})`;
                case WidgetController_type.IRelativeDimensionReference.RELATIVE_DIMENSION_REFERENCE_HEIGHT:
                    return `calc(${dimension.value} * ${computedStyles.height})`;
                case WidgetController_type.IRelativeDimensionReference.RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH: {
                    return `calc((${dimension.value} * ${widthCalculationRelativeUnit}) - ${containerLeft + containerRight}px)`;
                }
                case WidgetController_type.IRelativeDimensionReference.RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH: {
                    let referenceWidth = `${widthCalculationRelativeUnit} - ${widgetLeft}px - ${widgetRight}px - ${containerLeft}px`;
                    const elementCount = Math.floor(1 / ((width === null || width === void 0 ? void 0 : width.value) || 1));
                    if (elementCount < columns) {
                        referenceWidth = `${referenceWidth} - ${itemSpacing * elementCount}px`;
                    }
                    else if (elementCount === columns) {
                        referenceWidth = `${referenceWidth} - ${itemSpacing * (elementCount - 1) + containerRight}px`;
                    }
                    return `calc((${referenceWidth}) * ${dimension.value})`;
                }
                default:
                    return `${dimension.value}px`;
            }
        }
        default:
            return `${dimension.value}px`;
    }
};
const computeDimentionStylesForComponent = ({ style, columns = 1, itemSpacing = 0, containerPadding, widgetPadding, }) => {
    var _a, _b;
    const computedStyles = {};
    let styleComputationsKeys = ["width", "height"];
    if (((_a = style.height) === null || _a === void 0 ? void 0 : _a.type) === WidgetController_type.IDimensionType.TYPE_ABSOLUTE ||
        ((_b = style.height) === null || _b === void 0 ? void 0 : _b.reference) ===
            WidgetController_type.IRelativeDimensionReference.RELATIVE_DIMENSION_REFERENCE_DEVICE_HEIGHT)
        styleComputationsKeys = ["height", "width"];
    styleComputationsKeys.forEach((s) => {
        const dimension = style[s];
        const { width } = style;
        computedStyles[s] = getDimensionValue({
            computedStyles,
            dimension,
            width,
            itemSpacing,
            columns,
            containerPadding,
            widgetPadding,
        });
    });
    if (computedStyles.width)
        computedStyles.minWidth = computedStyles.width;
    if (computedStyles.height)
        computedStyles.minHeight = computedStyles.height;
    return computedStyles;
};

exports.computeDimentionStylesForComponent = computeDimentionStylesForComponent;
//# sourceMappingURL=dynamicSizing-aed281c8.js.map
